import { Box, Flex, IconFont, Menu, pointer, Text, usePopoverHeight } from '@byecode/ui'
import type { FieldInputType } from '@lighthouse/core'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React, { useState } from 'react'
import styled from 'styled-components'

import type { DesignColorSetting, GetFieldBlockLimitParams } from '@/components/StyleSetting'
import { DesignSetting, getFieldBlockInteractionStyleLimit, getFieldBlockStyleLimit } from '@/components/StyleSetting'
import { InteractionSetting } from '@/components/StyleSetting/InteractionSetting'

type ExtraFieldInputType = Extract<FieldInputType, 'slider' | 'file' | 'person' | 'relativeSelect'>

const SCxClose = styled(Flex)`
    width: 28px;
    height: 28px;
    background-color: var(--color-gray-100);
    border-radius: 50%;
    ${pointer}
`

const SCxContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 8px;
`

interface FieldExtraStyleProps extends GetFieldBlockLimitParams {
    prefixName: string
    inputType: ExtraFieldInputType
    colorSetting?: DesignColorSetting
}

const FieldExtraTitleMap: Record<ExtraFieldInputType, string> = {
    slider: '滑动条',
    file: '已上传附件',
    person: '人员标签',
    relativeSelect: '选项标签'
}

const fieldExtraLabelMap: Partial<Record<ExtraFieldInputType, Record<string, string>>> = {
    slider: {
        backgroundLabel: '未选段颜色',
        colorLabel: '已选段颜色'
    }
}

export const FieldExtraStyle: React.FC<FieldExtraStyleProps> = ({ prefixName, inputType, colorSetting, ...rest }) => {
    const [opened, setOpened] = useState(false)
    const { height: maxHeight, ref } = usePopoverHeight({ opened })
    const designProps = getFieldBlockStyleLimit(inputType, rest)
    const interactionProps = getFieldBlockInteractionStyleLimit(inputType, rest)
    const title = FieldExtraTitleMap[inputType]

    return (
        <Box ref={ref}>
            <Menu opened={opened} position="right" onChange={setOpened}>
                <Menu.Target>
                    <ListItem4ByecodeUi enableHover justifyContent="space-between" alignItems="center">
                        <Text>{title}</Text>
                        <IconFont type="ArrowRightSmall" fill="var(--color-gray-400)" size={16} />
                    </ListItem4ByecodeUi>
                </Menu.Target>
                <Menu.Dropdown style={{ padding: 0, maxHeight, overflow: 'hidden' }}>
                    <Box px={8}>
                        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center" style={{ height: 56 }}>
                            <Text weight={600} size={16}>
                                {title}
                            </Text>
                            <SCxClose onClick={() => setOpened(false)} justifyContent="center" alignItems="center">
                                <IconFont type="Close" fill="var(--color-gray-400)" />
                            </SCxClose>
                        </ListItem4ByecodeUi>
                    </Box>
                    <SCxContent>
                        <DesignSetting
                            prefixName={prefixName}
                            colorLabel="文本颜色"
                            {...fieldExtraLabelMap[inputType]}
                            {...designProps}
                            colorSetting={colorSetting}
                            afterSlot={interactionProps && <InteractionSetting prefixName={prefixName} {...interactionProps} />}
                        />
                    </SCxContent>
                </Menu.Dropdown>
            </Menu>
        </Box>
    )
}
